import {store} from '../store/store';
import {API_HOST} from '../config/_entrypoint';
import Vue from 'vue';
import axios from 'axios';
import Messages from '../translations/translations';
import VueI18n from 'vue-i18n';
import {HYDRA_DESCRIPTION} from '../constants/hydra';
import {FINISH_LOADING, START_LOADING} from '../store/modules/loading/mutation-types';
import {VIOLATION_LIST_RESET, VIOLATION_LIST_SET} from '../store/modules/violation/mutation-types';
import jwt from 'jsonwebtoken';
import {LOGIN, TOKEN_REFRESH} from "../constants/api-routes";

/** Initialization ***********************************************************/

const JSON_LD_MIME_TYPE = 'application/ld+json';

const http = axios.create({
    baseURL: API_HOST,
});
let notification = true;
let errorMsg = null;

/** Functions ****************************************************************/

function setNotification(newValue) {
    if (typeof newValue !== 'boolean') {
        return;
    }

    notification = newValue;
}

function getErrorMessage(error) {
    const i18n = new VueI18n({
        locale: store.getters['user/auth/locale'],
        messages: Messages
    });
    if (error.response.data.message === 'Bad credentials') {
        if (error.config.url.match('.*' + LOGIN)) {
            return i18n.t('user.auth.error.login');
        }
        if (error.config.url.match('.*' + TOKEN_REFRESH)) {
            return i18n.t('user.auth.error.expired');
        }
    }
    if (error.response.data[HYDRA_DESCRIPTION]) {
        return i18n.t(error.response.data[HYDRA_DESCRIPTION]);
    }
    if (error.response.data.error) {
        if(error.response.data.error.exception){
            return i18n.t(error.response.data.error.exception[0].message);
        }
        return i18n.t(error.response.data.error);
    }
}

function setHeaderAccept(options) {
    if (!(options.headers || {})['Accept']) {
        options.headers['Accept'] = JSON_LD_MIME_TYPE;
    }
}
function setHeaderContentType(options) {
    if (options.data && !options.headers['Content-Type']) {
        options.headers['Content-type'] = JSON_LD_MIME_TYPE;
    }
}
function setAuthenticationToken(options) {
    const token = localStorage.getItem('user-token');
    let decodedToken = jwt.decode(token);
    if (decodedToken && decodedToken.exp <= (Math.floor(Date.now() / 1000))) {
        return;
    }
    if (token) {
        options.headers['Authorization'] = `Bearer ${token}`;
    }
}
function setHeader(options) {
    setHeaderAccept(options);
    setHeaderContentType(options);
    setAuthenticationToken(options);
}

/** Interceptors *************************************************************/

// Loading

http.interceptors.request.use(config => {
    store.commit('loading/loading/' + START_LOADING);
    return config;
}, error => {
    store.commit('loading/loading/' + FINISH_LOADING);
    return Promise.reject(error);
});
http.interceptors.response.use(response => {
    store.commit('loading/loading/' + FINISH_LOADING);
    return response.data;
}, error => {
    store.commit('loading/loading/' + FINISH_LOADING);
    return Promise.reject(error);
});

// Required login

http.interceptors.response.use(response => {
    return response;
}, error => {
    if (error.response.status === 401) {
        store.dispatch('user/facebookAuth/logout');
        store.dispatch('user/auth/logout');
        store.dispatch('user/auth/requireLogin', true);
    }
    return Promise.reject(error);
});

// Notifications

http.interceptors.response.use(response => {
    return response;
}, error => {
    if (notification) {
        errorMsg = getErrorMessage(error);
        if (errorMsg) {
            Vue.$notify.error(errorMsg);
        }
    }
    return Promise.reject(error);
});

// Violations

http.interceptors.response.use(response => {
    store.commit('violation/list/' + VIOLATION_LIST_RESET);
    return response;
}, error => {
    if (error.response && error.response.data && error.response.data.violations) {
        let violations = {};
        error.response.data.violations.map(
            violation => (violations[violation.propertyPath] = violation.message)
        );
        store.commit('violation/list/' + VIOLATION_LIST_SET, violations);
    }
    return Promise.reject(error);
});

/** Main *********************************************************************/

export default (route, options = {}, showErrorNotification = true, sessionRefresh = true) => {
    options = {
        ...{
            headers: {},
            url: route
        },
        ...options
    };

    setNotification(showErrorNotification);
    setHeader(options);
    if (sessionRefresh && (localStorage.getItem('refresh-token') || store.getters['user/auth/facebookToken'])) {
        return store.dispatch('user/auth/refreshToken').then(() => {
            options.headers['Authorization'] = `Bearer ${localStorage.getItem('user-token')}`;
            return http(options);
        });
    }
    return http(options);
}



// WEBPACK FOOTER //
// ./src/utils/fetch.js